const translations = {

    en: {
        accord: {
          list: {
              error: "Error retrieving agreement requests: "
          },
          validate: {
            error: "Error validating the agreement: ",
            success: "Agreement validated successfully"
          },
          reject: {
            error: "Error rejecting the agreement: ",
            success: "Agreement rejected successfully"
          },
          sendMessage: {
            error: "Error sending message: ",
            success: "Message sent successfully"
          },
          getAgreement: {
            error: "Error retrieving the agreement request: "
          },
          getProformas: {
            error: "Error retrieving invoices: "
          },
          getProforma: {
            error: "Error retrieving invoice: "
          },
          validateProforma: {
            error: "Error validating invoice: ",
            error_line: "Error validating invoice line: "
          },
          rejectProforma: {
            error: "Error rejecting invoice: ",
            error_line: "Error rejecting invoice line: "
          },
          restoreProforma: {
            error: "Error restoring invoice: "
          }
        },
        actSpec: {
            getBon: {
                error: "Error retrieving provider: "
            },
            markAct: {
                error: "Error recording the action taken: ",
                success: "Act marked completed successfully recorded"
            }
        },
        auth: {
          error: "Authentication Failure: ",
          welcome: "Welcome ",
          updatePass: {
            success: "Your password has been successfully updated, please log in again using your new password",
            error: "Failed to update password: "
          }
        },
        consultation: {
            getConsult: {
                error: "Error retrieving consultations: "
            },
            getConsultData: {
                error: "Error retrieving the consultation: "
            },
            makeConsult: {
                error: "Error during consultation request: "
            },
            searchDrug: {
                error: "Error retrieving drugs: "
            },
            searchDisease: {
                error: "Error retrieving conditions: "
            },
            getSuggest: {
                error: "Error retrieving suggestions: "
            },
            updateConsult: {
                error: "Error updating the consultation: "
            },
            getClientConsult: {
                error: "Error retrieving consultations for this patient: "
            },
            medicalFile: {
                error_one: "Error retrieving medical record: ",
                error_two: "Error retrieving medical records: "
            },
            getPatientParam: {
                error: "Error retrieving parameter histories for this patient: "
            },
            makeAppointment: {
                error: "Error requesting an appointment: "
            },
            getPatientAppointment: {
                error: "Error retrieving appointments: ",
                error_data: "Error retrieving the appointment: "
            },
            updateQuantity: {
                success: "The prescribed quantity has been successfully updated",
                error: "Error updating the prescribed quantity: "
            },
            getActesConsult: {
                error: "Error retrieving consultation acts: "
            },
            getActeVerre: {
                error: "Error retrieving hospitalization acts: "
            },
            getActeHospi: {
                error: "Error retrieving hospitalization acts: "
            },
            addActeDetail: {
                error_one: "Error adding the exam to the voucher: ",
                error_two: "Error adding the specialized act to the voucher: ",
                error_three: "Error adding the act to the voucher: ",
                error_four: "Error adding the medication to the voucher: "
            },
            examDel: {
                error: "Error executing exams: "
            },
            acteDel: {
                error: "Error saving the performed act: "
            },
            drugDel: {
                error: "Error delivering medications: "
            },
            hospiDel: {
                error: "Error closing hospitalization: "
            }
        },
        contrat: {
            getBenef: {
                error: "Error retrieving beneficiaries: ",
                by_assu_error: "Error retrieving beneficiaries: "
            },
            getSouscript: {
                error: "Error retrieving subscribers: "
            },
            getGaranties: {
                error: "Error retrieving collateral: "
            },
            getActes: {
                error: "Error retrieving records: "
            },
            contratSearch: {
                error: "Error searching for contract: ",
                error_get_all: "Error retrieving contracts: ",
                error_get_ass_princ: "Error listing primary insured: ",
                error_get_all_benef: "Error retrieving beneficiaries: "
            },
            mappingActs: {
                success: "Mapping successfully performed",
                error: "Error during mapping: "
            },
            getHistory: {
                error_souscript: "Error retrieving subscriber history: ",
                error_contract: "Error retrieving contract history: ",
                error_benef: "Error retrieving beneficiary history: "
            }
        },
        factures: {
            getFactures: {
                error: "Error retrieving invoices: ",
                error_single: "Error retrieving invoice: "
            },
            getMotifs: {
                error: "Error retrieving exclusion reasons: "
            },
            rejet: {
                save_success: "Exclusion saved",
                save_error: "Error rejecting: ",
                restore_success: "Exclusion canceled",
                restore_error: "Error restoring: "
            },
            rembours: {
                request_success: "Request saved",
                request_error: "Error requesting refund: ",
                gets_error: "Error retrieving refunds: ",
                get_error: "Error retrieving refund: ",
                update_success: "Refund request saved",
                update_error: "Error saving refund request: "
            },
            calculate: {
                error_base_remb: "Error calculating reimbursement base: ",
                error_tm: "Error returning ticket modérateur: "
            },
            sendForPayment: {
                success_facture: "Invoice sent for payment",
                error_facture: "Error sending invoice for payment: ",
                error_rembours: "Error sending reimbursement for payment: "
            },
            prestations: {
                error_gets: "Error retrieving benefits: ",
                error_get: "Error retrieving benefit details: ",
                error_create: "Error initializing benefits: ",
                error_close: "Error closing benefits: ",
                error_delete: "Error deleting benefits: "
            }
        },
        help: {
            success: "Your message has been sent successfully, support will contact you as soon as possible.",
            error: "Error sending message: "
        },
        labo: {
            get_bon_error: "Error retrieving provider: ",
            delievery_exam_error: "Delivery successfully recorded",
            comment_success: "Comment successfully recorded",
            comment_error: "Error while commenting: ",
            getPatientResult: "Error retrieving test results: "
        },
        patient: {
            identification: {
              success_one: "Patient identified",
              success_two: "Patient data retrieved",
              error_one: "Patient identification failed: ",
              error_two: "Patient identification failed: "
            }
        },
        pharmacie: {
            get_bon_error: "Error retrieving provider: ",
            get_subs_error: "Error retrieving substitution requests: ",
            livraison_success: "Delivery successfully recorded",
            livraison_error: "Error during delivery: ",
            subs_req_success: "Substitution request successfully recorded",
            subs_req_error: "Error during substitution request: ",
            subs_validated_success: "Substitution successfully validated",
            subs_validated_error: "Error during substitution validation: ",
            subs_rejected_success: "Substitution successfully rejected",
            subs_rejected_error: "Error during substitution rejection: "
        },
        provider: {
              get_error: "Error retrieving provider: ",
              add_prov_bank_error: "Error saving provider payment information: ",
              search_act_error: "Error retrieving drugs: ",
              list_providers_error: "Error listing providers: ",
              list_provider_error: "Error listing providers: ",
              create_success: "Successfully saved",
              create_error: "Error saving: ",
              delete_success: "Provider successfully deleted",
              delete_error: "Error deleting provider: ",
              remove_tarif_success: "Tariff successfully removed",
              remove_tarif_error: "Error removing tariff: ",
              famille_act_error: "Error retrieving procedure families: ",
              get_type_error: "Error retrieving provider types: ",
              get_specialite_error: "Error retrieving provider specialties: ",
              add_specialite: "Error saving provider specialties: ",
              get_tarif_error: "Error retrieving tariffs: ",
              add_tarif_success: "Tariff successfully assigned to provider",
              add_tarif_error: "Error assigning tariff to provider: ",
              update_tarif_success: "Tariff successfully updated",
              update_tarif_error: "Error updating tariff: ",
              create_attr_success: "New tariff created and successfully assigned to provider",
              create_attr_error: "Error creating tariff: ",
              get_lettre_cle_error: "Error retrieving key letters: ",
              get_actes_error: "Error retrieving procedures: ",
              get_garanties_error: "Error retrieving guarantees: ",
              get_type_acte_error: "Error retrieving procedure types: ",
              get_medicaments_error: "Error retrieving drugs: ",
              deleted_success: " successfully deleted",
              deleted_error: "Error deleting ",
              get_optic_param_error: "Error listing optical parameters:",
              get_optic_grid_error: "Error retrieving the pricing grid:"
        },
        client: {
            register: {
              error_face_enrolled: "Warning, this face has already been enrolled for another patient",
              error_no_face: "The insured's face could not be verified.",
              face_enroll_success: "Client successfully enrolled",
              face_enroll_error: "The insured's face could not be registered. They will therefore not be able to use biometrics to identify themselves. However, they will receive their insured number by SMS in order to benefit from the alternative identification option via SMS",
              client_enroll_error: "Error updating client data: ",
              face_verif_error: "Error verifying face: ",
              client_listing_error: "Error retrieving clients: ",
              client_already_enrolled_error: "This client has already been enrolled",
              client_enroll_verif_error: "Error verifying client enrollment, please try again later!",
              enroll_start: "Enrollment started",
              get_client_error: "Error retrieving client: ",
              login_hist_error: "Error retrieving login history: "
            }
        },
        home: {
            error_data: "Error retrieving data: "
        },
        notifications: {
            error: "Error retrieving notifications: ",
            error_mark_read: "Error deleting notifications: "
        },
        parameter: {
            globalAct: {
              error: "Error listing global acts",
              success_mapping: "Standard act created",
              error_mapping: "Error creating standard act: ",
              success_mapping_update: "Standard act modified",
              error_mapping_update: "Error modifying standard act: ",
              success_mapping_delete: "Standard act deleted",
              error_mapping_delete: "Error deleting standard act: "
            }
        },
        rapports: {
            error: "Error retrieving data: "
        },
        users: {
            listing_error: "Error retrieving users: ",
            resend_user_param_confirm: "Parameters have been successfully sent to the user",
            resend_user_param_error: "Error resending parameters: ",
            reset_password_confirm: "Password successfully reset",
            reset_password_error: "Error resetting password: "
        },
        sinistre: {
          error: "Error retrieving claims: ",
        },
        cardTemplate: {
          cardManager: {
            title: "Card Manager"
          },
          field: {
            beneficiaryId: "Beneficiary ID",
            beneficiaryName: "Beneficiary Name",
            cardNumber: "Card Number",
            status: "Status",
            productionDate: "Production Date",
            deliveryDate: "Delivery Date",
            trackingNumber: "Tracking Number"
          },
          placeholder: {
            searchBeneficiary: "Search by beneficiary ID..."
          },
          searchBeneficiary: "Search Beneficiary",
          searchBeneficiaryHint: "Enter beneficiary ID to search for their cards",
          noCards: "No Cards Found",
          noCardsForBeneficiary: "No cards found for this beneficiary",
          cardsCount: "{count} card(s) found",
          filter: {
            status: "Filter by Status"
          },
          status: {
            dataValidation: "Data Validation",
            photoProcessing: "Photo Processing",
            templateApplication: "Template Application",
            qualityControl: "Quality Control",
            printing: "Printing",
            packaging: "Packaging",
            shipped: "Shipped",
            delivered: "Delivered",
            cancelled: "Cancelled"
          },
          view: {
            list: "List",
            preview: "Preview"
          },
          viewCards: "View Cards",
          quickPrint: "Quick Print",
          preview: {
            title: "Card Preview"
          },
          noPreview: "No preview available",
          generatePreview: "Generate Preview",
          generating: "Generating...",
          refresh: "Refresh",
          print: "Print",
          batchPrint: "Batch Print",
          batchPrintConfirm: "Do you want to print {count} selected card(s)?",
          selectedCount: "{count} card(s) selected",
          printOptions: {
            quality: "Print Quality",
            includeBackSide: "Include Back Side"
          },
          quality: {
            high: "High",
            medium: "Medium",
            low: "Low"
          },
          success: {
            cardPrinted: "Card printed successfully",
            batchPrinted: "Cards printed successfully",
            cardBlocked: "Card blocked successfully",
            cardUnblocked: "Card unblocked successfully",
            cardActivated: "Card activated successfully",
            cardGenerated: "Card generated successfully! ID: ",
            bulkActionCompleted: "Bulk action completed successfully"
          },
          error: {
            noBeneficiaryId: "Missing beneficiary ID",
            noCardsSelected: "No cards selected for printing",
            searchError: "Error searching cards: ",
            cardDetailsError: "Error retrieving card details: ",
            blockingError: "Error blocking card: ",
            unblockingError: "Error unblocking card: ",
            activationError: "Error activating card: ",
            generationError: "Error generating card: ",
            loadingError: "Error loading data: ",
            historyError: "Error loading history",
            productionStatusError: "Error loading production status"
          },
          info: {
            noCardsFound: "No cards found for this beneficiary"
          }
        },
        carteV2: {
          common: {
            save: 'Save',
            cancel: 'Cancel',
            delete: 'Delete',
            edit: 'Edit',
            view: 'View',
            close: 'Close',
            add: 'Add',
            search: 'Search',
            filter: 'Filter',
            export: 'Export',
            import: 'Import',
            refresh: 'Refresh',
            back: 'Back',
            next: 'Next',
            previous: 'Previous',
            confirm: 'Confirm',
            yes: 'Yes',
            no: 'No',
            loading: 'Loading...',
            success: 'Success',
            error: 'Error',
            warning: 'Warning',
            info: 'Information',
            actions: 'Actions',
            status: 'Status',
            date: 'Date',
            name: 'Name',
            description: 'Description',
            total: 'Total',
            active: 'Active',
            inactive: 'Inactive',
            all: 'All',
            none: 'None',
            select: 'Select',
            deselect: 'Deselect',
          },
          dashboard: {
            title: 'Complete Insurance Card Management',
            subtitle: 'Dashboard',
            stats: {
              totalCards: 'Total Cards',
              activeCards: 'Active Cards',
              pendingCards: 'Pending Cards',
              expiredCards: 'Expired Cards',
              monthlyProduction: 'Monthly Production',
              printingQueue: 'Printing Queue',
              templates: 'Templates',
              payments: 'Payments',
            },
            quickActions: {
              title: 'Quick Actions',
              newCard: 'New Card',
              batchGeneration: 'Batch Generation',
              templateManagement: 'Template Management',
              stockManagement: 'Stock Management',
              printing: 'Printing',
              payments: 'Payments',
            },
            recentActivity: {
              title: 'Recent Activity',
              noActivity: 'No recent activity',
            },
          },
          templates: {
            title: 'Card Template Management',
            list: 'Template List',
            create: 'Create Template',
            edit: 'Edit Template',
            delete: 'Delete Template',
            preview: 'Preview',
            duplicate: 'Duplicate',
            editor: {
              title: 'Template Editor',
              designCanvas: 'Design Canvas',
              properties: 'Properties',
              elements: 'Elements',
              palette: 'Palette',
              layers: 'Layers',
              logo: 'Logo',
              photo: 'Photo',
              text: 'Text',
              qrCode: 'QR Code',
              security: 'Security',
              position: 'Position',
              positionX: 'Position X',
              positionY: 'Position Y',
              width: 'Width',
              height: 'Height',
              rotation: 'Rotation',
              opacity: 'Opacity',
              colors: 'Colors',
              backgroundColor: 'Background Color',
              primaryColor: 'Primary Color',
              secondaryColor: 'Secondary Color',
              textColor: 'Text Color',
              gradient: 'Gradient',
              gradientStart: 'Gradient Start',
              gradientEnd: 'Gradient End',
              font: 'Font',
              fontSize: 'Font Size',
              fontFamily: 'Font Family',
              fontWeight: 'Font Weight',
              bold: 'Bold',
              italic: 'Italic',
              customLogo: 'Custom Logo',
              uploadLogo: 'Upload Logo',
              removeLogo: 'Remove Logo',
              upload: 'Upload',
              remove: 'Remove',
              templateName: 'Template Name',
              templateNameRequired: 'Template name is required',
              validationErrors: 'Validation Errors',
              noErrors: 'No Errors',
              saved: 'Template saved successfully',
              deleted: 'Template deleted successfully',
              error: 'Error saving template',
              selectElement: 'Select an element to edit its properties',
              addElement: 'Add element to canvas',
              deleteElement: 'Delete element',
            },
            sides: {
              front: 'Front',
              back: 'Back',
            },
          },
          generation: {
            title: 'Card Generation',
            individual: 'Individual Generation',
            batch: 'Batch Generation',
            form: {
              selectTemplate: 'Select Template',
              cardholderInfo: 'Cardholder Information',
              firstName: 'First Name',
              lastName: 'Last Name',
              cardNumber: 'Card Number',
              expiryDate: 'Expiry Date',
              photo: 'Photo',
              uploadPhoto: 'Upload Photo',
              generate: 'Generate',
              preview: 'Preview',
            },
            batch: {
              uploadFile: 'Upload File',
              fileFormat: 'File Format',
              csvFile: 'CSV File',
              excelFile: 'Excel File',
              downloadTemplate: 'Download Template',
              cardsToGenerate: 'Cards to Generate',
              totalCards: 'Total Cards',
              validCards: 'Valid Cards',
              invalidCards: 'Invalid Cards',
              startGeneration: 'Start Generation',
              progress: 'Progress',
            },
            messages: {
              success: 'Card generated successfully',
              batchSuccess: 'Batch cards generated successfully',
              error: 'Error during generation',
            },
          },
          production: {
            title: 'Production & Printing',
            queue: 'Queue',
            printing: 'Printing',
            batches: 'Batches',
            status: {
              pending: 'Pending',
              inProgress: 'In Progress',
              printing: 'Printing',
              completed: 'Completed',
              failed: 'Failed',
              cancelled: 'Cancelled',
            },
            batch: {
              batchNumber: 'Batch Number',
              totalCards: 'Total Cards',
              printed: 'Printed',
              remaining: 'Remaining',
              startPrinting: 'Start Printing',
              pausePrinting: 'Pause',
              resumePrinting: 'Resume',
              cancelBatch: 'Cancel Batch',
            },
            tracking: {
              title: 'Step Tracking',
              step: 'Step',
              design: 'Design',
              validation: 'Validation',
              printing: 'Printing',
              quality: 'Quality Control',
              delivery: 'Delivery',
            },
          },
          stock: {
            title: 'Stock Management',
            inventory: 'Inventory',
            items: {
              blankCards: 'Blank Cards',
              ribbons: 'Ribbons',
              laminates: 'Laminates',
              cleaningKits: 'Cleaning Kits',
            },
            fields: {
              itemName: 'Item',
              quantity: 'Quantity',
              minStock: 'Min Stock',
              maxStock: 'Max Stock',
              reorderLevel: 'Reorder Level',
              lastRestocked: 'Last Restocked',
              supplier: 'Supplier',
            },
            alerts: {
              lowStock: 'Low Stock',
              outOfStock: 'Out of Stock',
              reorderNeeded: 'Reorder Needed',
            },
            actions: {
              addStock: 'Add Stock',
              removeStock: 'Remove Stock',
              adjustStock: 'Adjust Stock',
              orderSupplies: 'Order Supplies',
            },
          },
          payment: {
            title: 'Payment Management',
            list: 'Payment List',
            statistics: 'Statistics',
            fields: {
              paymentId: 'Payment ID',
              amount: 'Amount',
              method: 'Method',
              status: 'Status',
              date: 'Date',
              reference: 'Reference',
            },
            methods: {
              cash: 'Cash',
              card: 'Card',
              transfer: 'Transfer',
              check: 'Check',
              online: 'Online',
            },
            status: {
              pending: 'Pending',
              completed: 'Completed',
              failed: 'Failed',
              refunded: 'Refunded',
            },
            stats: {
              totalRevenue: 'Total Revenue',
              pendingPayments: 'Pending Payments',
              completedPayments: 'Completed Payments',
              monthlyRevenue: 'Monthly Revenue',
            },
          },
          lifecycle: {
            title: 'Card Lifecycle',
            stages: {
              creation: 'Creation',
              validation: 'Validation',
              production: 'Production',
              active: 'Active',
              suspended: 'Suspended',
              expired: 'Expired',
              cancelled: 'Cancelled',
            },
            actions: {
              activate: 'Activate',
              suspend: 'Suspend',
              renew: 'Renew',
              cancel: 'Cancel',
              reissue: 'Reissue',
            },
          },
          search: {
            title: 'Advanced Search',
            basic: 'Basic Search',
            advanced: 'Advanced Search',
            filters: {
              status: 'Status',
              template: 'Template',
              dateRange: 'Date Range',
              cardNumber: 'Card Number',
              holderName: 'Holder Name',
              expiryDate: 'Expiry Date',
            },
            results: {
              found: 'results found',
              noResults: 'No results found',
            },
          },
          validation: {
            title: 'System Validation',
            rules: {
              required: 'This field is required',
              invalidFormat: 'Invalid format',
              tooShort: 'Too short',
              tooLong: 'Too long',
              invalidEmail: 'Invalid email',
              invalidPhone: 'Invalid phone',
              invalidDate: 'Invalid date',
            },
            messages: {
              validationPassed: 'Validation passed',
              validationFailed: 'Validation failed',
              pleaseCorrectErrors: 'Please correct the errors',
            },
          },
          notifications: {
            success: {
              saved: 'Saved successfully',
              deleted: 'Deleted successfully',
              updated: 'Updated successfully',
              created: 'Created successfully',
            },
            error: {
              saveFailed: 'Save failed',
              deleteFailed: 'Delete failed',
              updateFailed: 'Update failed',
              loadFailed: 'Load failed',
              networkError: 'Network error',
            },
            warning: {
              unsavedChanges: 'Unsaved changes',
              confirmDelete: 'Confirm deletion',
              cannotUndo: 'This action cannot be undone',
            },
          },
          analytics: {
            title: 'Analytics',
            overview: 'Overview',
            reports: 'Reports',
            metrics: {
              totalCards: 'Total Cards',
              activeCards: 'Active Cards',
              generationRate: 'Generation Rate',
              printingSpeed: 'Printing Speed',
              errorRate: 'Error Rate',
            },
            periods: {
              today: 'Today',
              thisWeek: 'This Week',
              thisMonth: 'This Month',
              thisYear: 'This Year',
              custom: 'Custom',
            },
          },
        }
    },
  
    fr: {
      accord: {
        list: {
            error: "Erreur lors de la récupération des demandes d'accord: "
        },
        validate: {
          error: "Erreur lors de la validation de l'acte: ",
          success: "Accord validé avec succès"
        },
        reject: {
          error: "Erreur lors du rejet de l'acte: ",
          success: "Accord rejeté avec succès"
        },
        sendMessage: {
          error: "Erreur lors de l'envoie du message: ",
          success: "Message envoyé avec succès"
        },
        getAccord: {
          error: "Erreur lors de a récupération de la demande d'accord': "
        },
        getProformas: {
            error: "Erreur lors des proformas: "
        },
        getProforma: {
            error: "Erreur lors de la proforma: "
        },
        validateProforma: {
            error: "Erreur lors de la validation de la proforma: ",
            error_line: "Erreur lors de la validation de la proforma: "
        },
        rejectProforma: {
            error: "Erreur lors du rejet de la proforma: ",
            error_line: "Erreur lors du rejet de la proforma: "
        },
        restoreProforma: {
            error: "Erreur lors de la restauration de la proforma: "
        }
      },
      actSpec: {
        getBon: {
            error: "Erreur lors de la récupération du provider: "
        },
        markAct: {
            error: "Erreur lors de l'enregistrement de l'acte posé: ",
            success: "Acte marqué éffectué enregistrée avec succès"
        }
      },
      auth: {
        error: "Echec d'authentification: ",
        welcome: "Bienvenue ",
        updatePass: {
          success: "Votre mot de passe a bien été mis à jour, veuilez vous reconnecter en utilisant votre nouveau mot de passe",
          error: "Echec de mise à jour du mot de passe: "
        }
      },
      consultation: {
        getConsult: {
            error: "Erreur lors de la récupération des consultation: "
        },
        getConsultData: {
            error: "Erreur lors de la récupération de la consultation: "
        },
        makeConsult: {
            error: "Erreur lors de la requete de consultation: "
        },
        searchDrug: {
            error: "Erreur lors de la récupération du drugs: "
        },
        searchDisease: {
            error: "Erreur lors de la récupération des affections: "
        },
        getSuggest: {
            error: "Erreur lors de la récupération des suggestions: "
        },
        updateConsult: {
            error: "Erreur lors de la mise à jour de la consultation: "
        },
        getClientConsult: {
            error: "Erreur lors de la récupération des consultations pour ce patient: "
        },
        medicalFile: {
            error_one: "Erreur lors de la récupération du dossier médical: ",
            error_two: "Erreur lors de la récupération du dossier médical: "
        },
        getPatientParam: {
            error: "Erreur lors de la récupération des historiques des paramètre pour ce patient: "
        },
        makeAppointment: {
            error: "Erreur lors de la requête de rendez-vous: "
        },
        getPatientAppointment: {
            error: "Erreur lors de la récupération des rendez-vous: ",
            error_data: "Erreur lors de la récupération du rendez-vous: "
        },
        updateQuantity: {
            success: "La quantité prescrite a bien été mise à jour",
            error: "Erreur lors de la mise à jour de la quantité prescrite: "
        },
        getActesConsult: {
            error: "Erreur lors de la récupération des actes de consultation: "
        },
        getActeVerre: {
            error: "Erreur lors de la récupération des actes d'hospitalisation: "
        },
        getActeHospi: {
            error: "Erreur lors de la récupération des actes d'hospitalisation: "
        },
        addActeDetail: {
            error_one: "Erreur lors de l'ajout de l'examen dans le bon: ",
            error_two: "Erreur lors de l'ajout de l'acte spécialisé dans le bon: ",
            error_three: "Erreur lors de l'ajout de l'acte dans le bon: ",
            error_four: "Erreur lors de l'ajout du medicament dans le bon: "
        },
        examDel: {
            error: "Erreur lors de l'exécution des examens: "
        },
        acteDel: {
            error: "Erreur lors de l'enregistrement de l'acte posé: "
        },
        drugDel: {
            error: "Erreur lors de la livraison des médicaments: "
        },
        hospiDel: {
            error: "Erreur lors de la clôture de l'hospitalisation: "
        }
      },
      contrat: {
        getBenef: {
            error: "Erreur lors de la récupération des bénéficiaires: ",
            by_assu_error: "Erreur lors de la récupération des bénéficiaires: "
        },
        getSouscript: {
            error: "Erreur lors de la récupération des souscripteurs: "
        },
        getGaranties: {
            error: "Erreur lors de la récupération des garanties: "
        },
        getActes: {
            error: "Erreur lors de la récupération des actes: "
        },
        contratSearch: {
            error: "Erreur lors de la recherche du contrat: ",
            error_get_all: "Erreur lors de la récupération des contrats: ",
            error_get_ass_princ: "Erreur lors de la liste des assurés principaux: ",
            error_get_all_benef: "Erreur lors de la récupération des bénéficiaires: "
        },
        mappingActs: {
            success: "Mapping éffectué avec succès",
            error: "Erreur lors du mapping: "
        },
        getHistory: {
            error_souscript: "Erreur lors de la récupération de l'historique des souscripteurs: ",
            error_contract: "Erreur lors de la récupération de l'historique des contrats: ",
            error_benef: "Erreur lors de la récupération de l'historique des beneficiaires: "
        }
      },
      factures: {
        getFactures: {
            error: "Erreur lors de la récupération des factures: ",
            error_single: "Erreur lors de la récupération de la facture: "
        },
        getMotifs: {
            error: "Erreur lors de la récupération des motifs d'exclusions: "
        },
        rejet: {
            save_success: "Exclusion enregistrée",
            save_error: "Erreur lors du rejet: ",
            restore_success: "Exclusion annulée",
            restore_error: "Erreur lors de la restauration: "
        },
        rembours: {
            request_success: "Demande enregistrée",
            request_error: "Erreur lors de la demande de remboursement: ",
            gets_error: "Erreur lors de la récupération des remboursements: ",
            get_error: "Erreur lors de la récupération du remboursement: ",
            update_success: "Demande de remboursement enregistrée",
            update_error: "Erreur lors de l'enregistrement de la demande de remboursement: "
        },
        calculate: {
            error_base_remb: "Erreur lors du calcul de la base de remboursement: ",
            error_tm: "Erreur lors du renvoie du ticket modérateur: "
        },
        sendForPayment: {
            success_facture: "Facture envoyée en paiment",
            error_facture: "Erreur lors de l'envoie de la facture en paiement: ",
            error_rembours: "Erreur lors de l'envoie du remboursement en paiement: "
        },
        prestations: {
            error_gets: "Erreur lors de la récupération des prestations: ",
            error_get: "Erreur lors de la récupération du détail de la prestation: ",
            error_create: "Erreur lors de l'initialisation des prestations: ",
            error_close: "Erreur lors de la clôture des prestations: ",
            error_delete: "Erreur lors de la suppression des prestations: "
        }
      },
      help: {
        success: "Votre message a bien été envoyé, le support vous contactera dans les plus brefs délais.",
        error: "Erreur lors de l'envoie du message: "
      },
      labo: {
        get_bon_error: "Erreur lors de la récupération du provider: ",
        deliever_exam_error: "Livraison enregistrée avec succès",
        comment_success: "Commentaire enregistrée avec succès",
        comment_error: "Erreur lors du commentaire: ",
        getPatientResult: "Erreur lors de récupération des résultats d'analyse: "
      },
      patient: {
        identification: {
            success_one: "Patient identifié",
            success_two: "Données Patient retrouvées",
            error_one: "Echec d'identification du patient: ",
            error_two: "Echec d'identification du patient: "
        }
      },
      pharmacie: {
        get_bon_error: "Erreur lors de la récupération du provider: ",
        get_subs_error: "Erreur lors de la récupération des demandes de substitution: ",
        livraison_success: "Livraison enregistrée avec succès",
        livraison_error: "Erreur lors de la livraison: ",
        subs_req_success: "Demande de substitution enregistrée avec succès",
        subs_req_error: "Erreur lors de la demande de substitution: ",
        subs_validated_success: "Substitution validée avec succès",
        subs_validated_error: "Erreur lors de la validation substitution: ",
        subs_rejected_success: "Substitution rejetée avec succès",
        subs_rejected_error: "Erreur lors du rejet de la substitution: "
      },
      provider: {
        get_error: "Erreur lors de la récupération du provider: ",
        add_prov_bank_error: "Erreur lors de l'enregistrement des infos de paiement du prestataire: ",
        search_act_error: "Erreur lors de la récupération du drugs: ",
        list_providers_error: "Erreur lors du listing des prestataire: ",
        list_provider_error: "Erreur lors du listing des prestataire: ",
        create_success: "Enregistré avec succès",
        create_error: "Erreur lors de l'engistrement : ",
        delete_success: "Prestataire supprimé avec succès",
        delete_error: "Erreur lors de la suppression du prestataire: ",
        remove_tarif_success: "Tarif retiré avec succès",
        remove_tarif_error: "Erreur lors du retrait du tarif: ",
        famille_act_error: "Erreur lors de la récupération des familles d'acte: ",
        get_type_error: "Erreur lors de la récupération des types de prestataire: ",
        get_specialite_error: "Erreur lors de la récupération des spécialités de prestataire: ",
        add_specialite: "Erreur lors de l'enregistrement des spécialités du prestataire: ",
        get_tarif_error: "Erreur lors de la récupération des tarifs: ",
        add_tarif_success: "Tarification assignée au prestataire avec succès",
        add_tarif_error: "Erreur lors de l'assignation du tarif au prestataire: ",
        update_tarif_success: "Tarrification mise à jour avec succès",
        update_tarif_error: "Erreur lors de la modification du tarif: ",
        create_attr_success: "Nouvelle tarification créée et assignée au prestataire avec succès",
        create_attr_error: "Erreur lors de la creation du tarif: ",
        get_lettre_cle_error: "Erreur lors de la récupération des lettres clés: ",
        get_lettre_cle_error: "Erreur lors de la récupération des types de prestataire: ",
        get_actes_error: "Erreur lors de la récupération des actes: ",
        get_garanties_error: "Erreur lors de la récupération des garanties: ",
        get_type_acte_error: "Erreur lors de la récupération des types de prestataire: ",
        get_actes_error: "Erreur lors de la récupération des actes: ",
        get_drugs_error: "Erreur lors de la récupération des Medicaments: ",
        deleted_success: " supprimé avec succès",
        deleted_error: "Erreur lors de la supression du ",
        get_optic_param_error: "Erreur lors du listing des paramètres optique:",
        get_optic_grid_error: "Erreur lors de récupération de la grille tarifaire:"
      },
      client: {
        register: {
            error_face_enrolled: "Attention, ce visage a déjà été enrôlé pour une autre patient",
            error_no_face: "Le visage de l'assuré n'a pas pu être vérifié.",
            face_enroll_success: "Client enrollé avec succès",
            face_enroll_error: "Le visage de l'assuré n'a pas pu être enregistré. Il ne pourra par conséquent pas utiliser la biométrie pour s'identifier. Il recevra cependant par sms son numéro d'assuré afin de bénéficier de l'option d'identification alternative via sms",
            client_enroll_error: "Erreur lors de la mise à jour des données du client: ",
            face_verif_error: "Erreur lors de la vérification du visage: ",
            client_listing_error: "Erreur lors de récupération des clients: ",
            client_alread_enrolled_error: "Ce client a déjà été enrollé",
            client_enroll_verif_error: "Erreur lors de la vérification de l'enrollement du client, veuillez réessayer plus tard!",
            enroll_start: "Début de l'enrôlement",
            get_client_error: "Erreur lors de récupération du client: ",
            login_hist_error: "Erreur lors de récupération de l'historique de connexion: "
        }
      },
      home: {
        error_data: "Erreur lors de la récupération des données: "
      },
      notifications: {
        error: "Erreur lors de la récupération des notifications: ",
        error_mark_read: "Erreur lors de la suppression des notifications: ",
      },
      parameter: {
        globalAct: {
            error: "Erreur lors du listing des actes globaux",
            success_mapping: "l'acte standart a été crée",
            error_mapping: "Erreur lors de la création de l'acte standart: ",
            success_mapping_update: "l'acte standart a été modifié",
            error_mapping_update: "Erreur lors de la modification de l'acte standart: ",
            success_mapping_delete: "l'acte standart a été supprimé",
            error_mapping_delete: "Erreur lors de la suppression de l'acte standart: "
        }
      },
      rapports: {
        error: "Erreur lors de la récupération des données: "
      },
      users: {
        listing_error: "Erreur lors de la récupération des ",
        resend_user_param_confirm: "Les paramètres ont bien été envoyés à l'utilsateur",
        resend_user_param_error: "Erreur lors du renvoie des paramètres : ",
        reset_password_confirm: "Le mot de passe a bien été réinitialisé",
        reset_password_error: "Erreur lors de la réinitialisation du mot de passe : "
      },
      sinistre: {
        error: "Erreur lors de la récupération des sinistres: ",
      },
      restrictions: {
        list: {
          error: "Erreur lors de la récupération des restrictions : ",
          title: "Restrictions Clients",
          noData: "Aucune restriction trouvée",
          search: "Rechercher des restrictions..."
        },
        create: {
          error: "Erreur lors de la création de la restriction : ",
          success: "Restriction créée avec succès",
          title: "Nouvelle Restriction",
          selectClient: "Sélectionner un Client",
          selectType: "Sélectionner un Type de Restriction",
          selectSeverity: "Sélectionner une Sévérité"
        },
        update: {
          error: "Erreur lors de la mise à jour de la restriction : ",
          success: "Restriction mise à jour avec succès",
          title: "Modifier la Restriction"
        },
        delete: {
          error: "Erreur lors de la suppression de la restriction : ",
          success: "Restriction supprimée avec succès",
          confirm: "Êtes-vous sûr de vouloir supprimer cette restriction ?"
        },
        get: {
          error: "Erreur lors de la récupération de la restriction : "
        },
        stats: {
          error: "Erreur lors de la récupération des statistiques : ",
          activeRestrictions: "Restrictions Actives",
          impactedClients: "Clients Impactés",
          restrictionsByType: "Restrictions par Type"
        },
        validate: {
          error: "Erreur lors de la validation de la restriction : "
        },
        export: {
          error: "Erreur lors de l'export des restrictions : ",
          success: "Export des restrictions réussi"
        },
        levels: {
          Individual: "Bénéficiaire",
          Family: "Famille", 
          Group: "Groupe/Collège",
          Policy: "Police"
        },
        types: {
          ProviderBlacklist: "Liste Noire Prestataire",
          NetworkRestriction: "Restriction Réseau",
          ActeRestriction: "Restriction Acte Médical",
          ServiceRestriction: "Restriction Service",
          AmountLimitation: "Limitation Montant",
          FrequencyLimitation: "Limitation Fréquence",
          GeographicLimitation: "Limitation Géographique",
          TimeLimitation: "Limitation Temporelle",
          MedicalRestriction: "Restriction Médicale",
          AdministrativeBlock: "Blocage Administratif",
          FraudSuspicion: "Suspicion Fraude",
          PaymentDefault: "Défaut Paiement",
          PreAuthorizationRequired: "Pré-autorisation Requise",
          CustomRestriction: "Restriction Personnalisée"
        },
        severity: {
          Info: "Information",
          Warning: "Avertissement",
          Blocking: "Blocage Partiel",
          TotalBlock: "Blocage Total"
        },
        fields: {
          client: "Client",
          type: "Type",
          severity: "Sévérité",
          startDate: "Date Début",
          endDate: "Date Fin",
          reason: "Raison",
          appliedBy: "Appliqué Par",
          description: "Description",
          status: "Statut"
        }
      },
      accessControl: {
        rules: {
          error: "Erreur lors de la récupération des règles d'accès : ",
          get: {
            error: "Erreur lors de la récupération de la règle : "
          },
          create: {
            error: "Erreur lors de la création de la règle d'accès : ",
            success: "Règle d'accès créée avec succès"
          },
          update: {
            error: "Erreur lors de la mise à jour de la règle d'accès : ",
            success: "Règle d'accès mise à jour avec succès"
          },
          delete: {
            error: "Erreur lors de la suppression de la règle d'accès : ",
            success: "Règle d'accès supprimée avec succès"
          }
        },
        evaluate: {
          error: "Erreur lors de l'évaluation de l'accès : ",
          success: "Évaluation d'accès terminée"
        },
        simulate: {
          error: "Erreur lors de la simulation d'accès : ",
          title: "Simulateur d'Accès",
          result: "Résultat de la Simulation"
        }
      },
      cardTemplate: {
        cardManager: {
          title: "Gestionnaire de Cartes"
        },
        field: {
          beneficiaryId: "ID Bénéficiaire",
          beneficiaryName: "Nom du Bénéficiaire",
          cardNumber: "Numéro de Carte",
          status: "Statut",
          productionDate: "Date de Production",
          deliveryDate: "Date de Livraison",
          trackingNumber: "Numéro de Suivi"
        },
        placeholder: {
          searchBeneficiary: "Rechercher par ID bénéficiaire..."
        },
        searchBeneficiary: "Rechercher un Bénéficiaire",
        searchBeneficiaryHint: "Entrez l'ID du bénéficiaire pour rechercher ses cartes",
        noCards: "Aucune Carte Trouvée",
        noCardsForBeneficiary: "Aucune carte trouvée pour ce bénéficiaire",
        cardsCount: "{count} carte(s) trouvée(s)",
        filter: {
          status: "Filtrer par Statut"
        },
        status: {
          dataValidation: "Validation des Données",
          photoProcessing: "Traitement Photo",
          templateApplication: "Application du Modèle",
          qualityControl: "Contrôle Qualité",
          printing: "Impression",
          packaging: "Emballage",
          shipped: "Expédié",
          delivered: "Livré",
          cancelled: "Annulé"
        },
        view: {
          list: "Liste",
          preview: "Aperçu"
        },
        viewCards: "Voir les Cartes",
        quickPrint: "Impression Rapide",
        preview: {
          title: "Aperçu de la Carte"
        },
        noPreview: "Aucun aperçu disponible",
        generatePreview: "Générer l'Aperçu",
        generating: "Génération en cours...",
        refresh: "Actualiser",
        print: "Imprimer",
        batchPrint: "Impression Groupée",
        batchPrintConfirm: "Voulez-vous imprimer {count} carte(s) sélectionnée(s) ?",
        selectedCount: "{count} carte(s) sélectionnée(s)",
        printOptions: {
          quality: "Qualité d'Impression",
          includeBackSide: "Inclure le Verso"
        },
        quality: {
          high: "Haute",
          medium: "Moyenne",
          low: "Basse"
        },
        success: {
          cardPrinted: "Carte imprimée avec succès",
          batchPrinted: "Cartes imprimées avec succès",
          cardBlocked: "Carte bloquée avec succès",
          cardUnblocked: "Carte débloquée avec succès",
          cardActivated: "Carte activée avec succès",
          cardGenerated: "Carte générée avec succès! ID: ",
          bulkActionCompleted: "Action groupée terminée avec succès"
        },
        error: {
          noBeneficiaryId: "ID bénéficiaire manquant",
          noCardsSelected: "Aucune carte sélectionnée pour l'impression",
          searchError: "Erreur lors de la recherche des cartes: ",
          cardDetailsError: "Erreur lors de la récupération des détails de la carte: ",
          blockingError: "Erreur lors du blocage de la carte: ",
          unblockingError: "Erreur lors du déblocage de la carte: ",
          activationError: "Erreur lors de l'activation de la carte: ",
          generationError: "Erreur lors de la génération de la carte: ",
          loadingError: "Erreur lors du chargement des données: ",
          historyError: "Erreur lors du chargement de l'historique",
          productionStatusError: "Erreur lors du chargement du statut de production"
        },
        info: {
          noCardsFound: "Aucune carte trouvée pour ce bénéficiaire"
        }
      }
    },
  
  };
  
  export default translations;